import connector from 'Utils/connector';
import {
  usageTrackReachedItemEnd,
  usageTrackReachedSectionEnd,
} from 'Webapp/shared/app/redux/actions/usage-actions';
import SectionContent from 'Webapp/shared/app/views/section/content';

export default connector({
  actions: { usageTrackReachedItemEnd, usageTrackReachedSectionEnd },
})(SectionContent);
